import { WhitelabelConfig } from '@whitelabel/types';

const AgodaWhitelabelConfig: WhitelabelConfig = {
    displayName: 'Agoda',
    termsOfUseUrl: 'https://www.agoda.com/info/termsofuse.html',
    privacyPolicyUrl: 'https://www.agoda.com/info/privacy.html',
};

export default AgodaWhitelabelConfig;
